<template>
  <Modal width="400px" height="424px" @close="$emit('close')">
    <h2>Загрузить с xml</h2>
    <VFiledrop
      accept="text/xml"
      @upload="loadFile"
      height="150px"
      style="margin: 16px 0 auto"
    />

    <transition name="fade">
      <VFile v-if="file" :value="file" />
    </transition>

    <Button
      @click="sendFile"
      width="100%"
      height="48px"
      text="Добавить"
      class="btn-primary"
      style="margin-top: 16px"
      :loading="loading"
    />
    <Button
      @click="$emit('close')"
      width="100%"
      height="48px"
      text="Отменить"
      class="btn-secondary"
      style="margin-top: 16px"
    />
  </Modal>
</template>

<script>
import Modal from "@/components/Modals/Modal.vue";
import VFiledrop from "@/components/VFiledrop.vue";
import VFile from "@/components/VFile.vue";
import Button from "@/components/Button.vue";

import axios from "@/utils/axios.js";

export default {
  components: {
    Modal,
    VFiledrop,
    VFile,
    Button,
  },
  props: {
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      file: null,
      loading: false,
    };
  },
  methods: {
    loadFile(file) {
      this.file = file;
    },
    async sendFile() {
      if (this.file && this.url) {
        const data = new FormData();
        data.append("file", this.file);

        this.loading = true;

        try {
          await axios.post(this.url, data);
          this.$root.popup("Добавлено", null, "success");
        } catch (err) {
          Promise.reject(err);
        }
        this.loading = false;
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
